module.exports = __webpack_public_path__ + "static/img/DAN-ANNABLE.a793012.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/DAN-ANNABLE.jpg
// module id = M+2P
// module chunks = 0